module.exports = __webpack_public_path__ + "80fdb1c51de66fbd0fafd2aef6d80728.svg";